<template>

  <v-tooltip bottom  v-if="types[type - 1]">

    <template v-slot:activator="{ on, attrs }">
       
      <div :class="{ 'is-small': isSmall }">
                 
        <v-btn
          x-small
          v-on="on"
          v-bind="attrs"
          :color="types[type - 1].color"
          class="px-1 py-4"
        >
          <v-icon v-if="types[type - 1]" small>{{ types[type - 1].icon }}</v-icon>
        </v-btn>
      </div>
    </template>
    <span v-if="hint!==''||hint!==''">{{ hint }}</span>
    <span v-else> {{ types[type - 1].tooltip }}</span>
  </v-tooltip>
</template>

<style lang="scss">
.is-small {
  .v-btn:not(.v-btn--round).v-size--x-small {
    height: 18px;
    width: 20px;
    min-width: 0px;
    padding: 0 8.8888888889px !important;
  }
  .v-btn > .v-btn__content .v-icon {
    font-size: small !important;
  }
}
</style>

<script>
export default {
  name: "subscription-state",
  props: {
    type: Number,
    isSmall: Boolean,
    hint:{
      type:String,
      default:''
    }
    
  },
  data: () => ({
    types: [
      {
        icon: "mdi-close",
        tooltip: "غير مشترك",
        color: "error",
      },
      {
        icon: "mdi-check",
        tooltip: "مشترك",
        color: "success",
      },
      {
        icon: "mdi-check",
        tooltip: "منتهي",
        color: "warning",
      },
      {
        icon: "mdi-minus",
        tooltip: "",
        color: "secondary  lighten-4",
      }
    ],
  }),
};
</script>
